import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import { api, go } from './util';

/**
 * /projects/follow/{token} and /projects/unfollow/{token}: the links in project emails for people outside Voucha.
 * Nothing happens until they press the button (so link checkers in email apps can't confirm or unfollow for them).
 */
export default class ProjectFollow extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.token = String(m.route.param('token') || '');
    this.unsubscribe = /\/unfollow\//.test(m.route.get() || '');
    this.done = null;
    this.error = null;
  }
  send() {
    this.busy = true;
    app.request({
      method: 'POST',
      url: api('/projects-follow-link'),
      body: {
        token: this.token,
        unsubscribe: this.unsubscribe
      },
      errorHandler: () => {}
    }).then(r => {
      this.done = r.message;
      this.slug = r.slug;
    }).catch(e => this.error = e && e.response && e.response.message || 'This link isn’t valid any more.').then(() => {
      this.busy = false;
      m.redraw();
    });
  }
  view() {
    return m("div", {
      className: "VEvt VEvt-empty"
    }, m("i", {
      className: this.unsubscribe ? 'far fa-bell-slash' : 'fas fa-bell',
      "aria-hidden": "true"
    }), this.done || this.error ? m("div", null, m("h3", null, this.done || this.error), this.slug ? m(Button, {
      className: "Button",
      onclick: go('/projects/' + this.slug)
    }, "See the project") : m(Button, {
      className: "Button",
      onclick: go('/projects')
    }, "Projects")) : m("div", null, m("h3", null, this.unsubscribe ? 'Unfollow this project?' : 'Confirm you want to follow this project'), m("p", null, this.unsubscribe ? 'You won’t get any more emails about it.' : 'We’ll email you when it’s halfway done and when it’s completed.'), m(Button, {
      className: "Button Button--primary",
      loading: this.busy,
      onclick: () => this.send()
    }, this.unsubscribe ? 'Unfollow' : 'Confirm')));
  }
}
flarum.reg.add('voucha-community', 'forum/projects/ProjectFollow', ProjectFollow);